import { useEffect } from 'react';
import { useEffectEvent } from 'use-effect-event';
import isSize, { useIsSize } from '../utils/responsive/isSize';
import Sizes from '../utils/responsive/Sizes';

const breakPointSize = Sizes.SM;

export const getScrollContainer = () => {
  if (isSize(breakPointSize)) {
    return document.documentElement;
  }
  const content = document.querySelector('#content');
  return content instanceof HTMLElement ? content : null;
};

interface ListenToPostScrollHandlerArgs {
  isScrolledWithUserInteraction: boolean;
}

const listenToPostScroll = (
  handler: (args: ListenToPostScrollHandlerArgs) => void,
) => {
  const scrollContainer = getScrollContainer();

  if (!scrollContainer) {
    return () => {};
  }

  const target =
    scrollContainer === document.documentElement ? document : scrollContainer;

  let timer: ReturnType<typeof setTimeout> | null = null;
  let isScrolledWithUserInteraction = false;

  const onScroll = () => {
    handler({ isScrolledWithUserInteraction });
  };

  const onWheel = () => {
    isScrolledWithUserInteraction = true;

    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      isScrolledWithUserInteraction = false;
    }, 100);
  };

  target.addEventListener('scroll', onScroll, { passive: true });
  target.addEventListener('wheel', onWheel, { passive: true });
  return () => {
    target.removeEventListener('scroll', onScroll);
    target.removeEventListener('wheel', onWheel);
    if (timer) clearTimeout(timer);
  };
};

export const useListenToPostScroll = (
  handler: (args: ListenToPostScrollHandlerArgs) => void,
) => {
  const isMatched = useIsSize(breakPointSize);

  const onScroll = useEffectEvent(handler);
  useEffect(() => {
    return listenToPostScroll(onScroll);
  }, [isMatched]);
};

export default listenToPostScroll;
